import React from 'react'
import Select from 'react-select';
import { showSuccessMsg} from '../../util/messagesUtil';
import $ from 'jquery'


export class ModalImportarPrecos extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      empresaReferencia: null,
      tipoVeiculo: null,
      tipoVeiculoAImporta: null
    }
  }
  
  handleEmpresaChange(empresaReferencia){
    this.setState({empresaReferencia: empresaReferencia})
  }

  handleTipoVeiculoChange(tipoVeiculo){
    this.setState({tipoVeiculo: tipoVeiculo});
  }

  handleTipoVeiculoAImportarChange(tipoVeiculo){
    this.setState({tipoVeiculoAImporta: tipoVeiculo});
  }

  fecharModal () {
    $('#modalImportarPrecos').modal('hide');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  }
  
  importarPrecos(){
    const tipoVeiculo = this.state.tipoVeiculo ? this.state.tipoVeiculo.value : '';
    const tipoVeiculoAImporta = this.state.tipoVeiculoAImporta ? this.state.tipoVeiculoAImporta.value : ';'    
    this.props.importarPrecos(this.state.empresaReferencia.value, this.props.codigoEmpresaSelecionada, tipoVeiculo, tipoVeiculoAImporta)
      .then(() => {
        this.props.buscarPrecos(this.props.codigoEmpresaSelecionada)
        showSuccessMsg('Importaçao realizada.')
        this.fecharModal();
        this.setState({tipoVeiculo: null, tipoVeiculoAImporta: null, empresaReferencia: null});
      })
    
  }

  exibirLimparTipoPreco() {
    if (this.state.tipoVeiculo) {
        return <button type="button" className="close" aria-label="Close" style={{color: 'red'}}
                       onClick={() => {this.setState({tipoVeiculo: null, tipoVeiculoAImporta: null})}}>
            <i className="material-icons">&#xe5cd;</i>
        </button>
    }
  }

  exibirLimparTipoVeiculoAImportar() {
    if (this.state.tipoVeiculoAImporta) {
        return <button type="button" className="close" aria-label="Close" style={{color: 'red'}}
                       onClick={() => {this.setState({tipoVeiculoAImporta: null})}}>
            <i className="material-icons">&#xe5cd;</i>
        </button>
    }
  }

  render () {
    return (
      <div className="modal fade show" id="modalImportarPrecos" role="dialog"
           aria-labelledby="modalImportarPrecos" aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">cloud_upload</span>
                Importar preços de uma empresa
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                onClick={() => this.fecharModal()}>
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="vx-modal-body" style={{ background: '#fff' }}>
              <div className="row">
                <div className="col-8 mb-3">
                  <Select
                    maxMenuHeight={400}
                    menuPlacement="auto"
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione uma empresa'
                    options={this.props.empresas.map(elemento => ({
                      label: elemento.nomeFantasia,
                      value: elemento.id
                    }))}
                    value={this.state.empresaReferencia ? ({
                      label: this.state.empresaReferencia.label,
                      value: this.state.empresaReferencia.id
                    }) : ''}
                    onChange={value => this.handleEmpresaChange(value)}
                  />
                  <div className='mt-3'>
                    <Select
                      maxMenuHeight={400}
                      menuPlacement="auto"
                      noOptionsMessage={() => ('Nenhuma opção encontrada')}
                      placeholder='Tipo veículo'
                      options={this.props.tiposPreco.map(elemento => ({
                          label: elemento.descricaoTipoPreco,
                          value: elemento.tipoPreco
                      }))}
                      value={this.state.tipoVeiculo ? ({
                        label: this.state.tipoVeiculo.label,
                        value: this.state.tipoVeiculo.value
                      }) : ''}
                      onChange={value => this.handleTipoVeiculoChange(value)}
                    />
                  </div>
                  {this.exibirLimparTipoPreco()}
                </div>
                {this.state.tipoVeiculo ? <div className='col-8 mb-3'>
                  <div className='mt-3'>
                    <div><label>Importar convertendo para: </label></div>
                    <Select
                      maxMenuHeight={400}
                      menuPlacement="auto"
                      noOptionsMessage={() => ('Nenhuma opção encontrada')}
                      placeholder='Tipo veículo'
                      options={this.props.tiposPreco.map(elemento => ({
                          label: elemento.descricaoTipoPreco,
                          value: elemento.tipoPreco
                      }))}
                      value={this.state.tipoVeiculoAImporta ? ({
                        label: this.state.tipoVeiculoAImporta.label,
                        value: this.state.tipoVeiculoAImporta.value
                      }) : ''}
                      onChange={value => this.handleTipoVeiculoAImportarChange(value)}
                    />
                  </div>
                  {this.exibirLimparTipoVeiculoAImportar()}
                </div> : ''}
              </div>
            </div>
            <div className="vx-modal-footer">
              <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                onClick={() => this.fecharModal()}>
                Cancelar
              </button>
              <button type="button" onClick={() => this.importarPrecos()}
                     disabled={!this.state.empresaReferencia}
                     className="vx-modal-btn-confirmar">
                <span className="material-icons" style={{ fontSize: 15 }}>cloud_upload</span>
                Importar
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default (ModalImportarPrecos);
